// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"2b908d17","413":"1469cc57","988":"9b85da91"}[chunkId] + ".chunk.js";
};